import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { SessionActions } from "../actions/guideStreamActions";

export default function assignedMentorReducer(state = initialState.assignedMentors, action: SessionActions) {
    switch (action.type) {
        case types.LOAD_ASSIGNED_MENTORS_SUCCESS:
            return action.assignedMentors;
        default:
            return state;
    }
}
